import { Grid } from '@kirz/mui-admin';
import React from 'react';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Wedden, lonen, vervangingsinkomsten en pensioenen"
      description="Gelieve deze documenten te bezorgen:"
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <FilesField
          name="foreign_income_documents"
          title="Fiches betreffende uw buitenlandse beroepsinkomsten"
          xs={12}
          md={12}
        />
        <FilesField
          name="foreign_pension_documents"
          title="Fiches betreffende uw buitenlandse pensioenen"
          xs={12}
          md={12}
        />
        <FilesField
          name="replacement_income_documents"
          title="Attesten inzake uw vervangingsinkomsten"
          xs={12}
          md={12}
        />
        <FilesField
          name="replacement_payment_documents"
          title="Attest van uw bijdrage aan een hulp kas voor het ontvangen van een vervangingsuitkering"
          xs={12}
          md={12}
        />
        <FilesField
          name="study_years_documents"
          title="Attest van de pensioendienst met betrekking tot het afkopen van studiejaren"
          xs={12}
          md={12}
        />
      </Grid>
    </StepWrapper>
  );
}
